import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Order"
});
const _hoisted_1 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.01",
  d: "M1.89758 0.959999H15.9776V15.04H1.89758V0.959999Z",
  fill: "#202425"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M3.30566 4.71467C3.30566 4.46813 3.35422 4.22401 3.44857 3.99624C3.54291 3.76847 3.6812 3.56152 3.85552 3.38719C4.02985 3.21287 4.2368 3.07458 4.46457 2.98024C4.69234 2.88589 4.93646 2.83733 5.183 2.83733H12.6923C12.9389 2.83733 13.183 2.88589 13.4108 2.98024C13.6385 3.07458 13.8455 3.21287 14.0198 3.38719C14.1941 3.56152 14.3324 3.76847 14.4268 3.99624C14.5211 4.22401 14.5697 4.46813 14.5697 4.71467V12.6933C14.5697 12.9399 14.5211 13.184 14.4268 13.4118C14.3324 13.6395 14.1941 13.8465 14.0198 14.0208C13.8455 14.1951 13.6385 14.3334 13.4108 14.4278C13.183 14.5221 12.9389 14.5707 12.6923 14.5707H5.183C4.93646 14.5707 4.69234 14.5221 4.46457 14.4278C4.2368 14.3334 4.02985 14.1951 3.85552 14.0208C3.6812 13.8465 3.54291 13.6395 3.44857 13.4118C3.35422 13.184 3.30566 12.9399 3.30566 12.6933V4.71467Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M5.65234 2.83733C5.65234 2.46391 5.80069 2.10578 6.06474 1.84173C6.32879 1.57768 6.68692 1.42933 7.06034 1.42933H10.815C11.1884 1.42933 11.5466 1.57768 11.8106 1.84173C12.0747 2.10578 12.223 2.46391 12.223 2.83733C12.223 3.21076 12.0747 3.56889 11.8106 3.83294C11.5466 4.09699 11.1884 4.24533 10.815 4.24533H7.06034C6.87544 4.24533 6.69235 4.20891 6.52153 4.13815C6.3507 4.0674 6.19548 3.96368 6.06474 3.83294C5.80069 3.56889 5.65234 3.21076 5.65234 2.83733Z",
  fill: "#A5ACBE"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", {
  d: "M5.4176 7.53067C5.4176 7.34396 5.49177 7.16489 5.6238 7.03286C5.75582 6.90084 5.93489 6.82667 6.1216 6.82667H11.7536C11.9403 6.82667 12.1194 6.90084 12.2514 7.03286C12.3834 7.16489 12.4576 7.34396 12.4576 7.53067C12.4576 7.71738 12.3834 7.89645 12.2514 8.02847C12.1194 8.1605 11.9403 8.23467 11.7536 8.23467H6.1216C5.93489 8.23467 5.75582 8.1605 5.6238 8.02847C5.49177 7.89645 5.4176 7.71738 5.4176 7.53067ZM5.4176 10.3467C5.4176 10.16 5.49177 9.98089 5.6238 9.84887C5.75582 9.71684 5.93489 9.64267 6.1216 9.64267H8.9376C9.12432 9.64267 9.30338 9.71684 9.43541 9.84887C9.56743 9.98089 9.6416 10.16 9.6416 10.3467C9.6416 10.5334 9.56743 10.7124 9.43541 10.8445C9.30338 10.9765 9.12432 11.0507 8.9376 11.0507H6.1216C6.02915 11.0507 5.93761 11.0325 5.85219 10.9971C5.76678 10.9617 5.68917 10.9098 5.6238 10.8445C5.55843 10.7791 5.50657 10.7015 5.47119 10.6161C5.43581 10.5307 5.4176 10.4391 5.4176 10.3467Z",
  fill: "white"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_6);
}
var Order = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { Order as default };
